import React, {useState} from 'react';
import {CustomInput, Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import "./index.css";
import PropTypes from "prop-types";
import * as _ from 'lodash';

const FilterTypeComponent = (props) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen(prevState => !prevState);
    const [dropdownItem, setDropdownItem] = useState(props.defaultFilter);

    return (
        <Dropdown isOpen={dropdownOpen} toggle={() => {
        }} className="home-content-type text-align-left">

            <DropdownToggle caret onClick={toggle}>
                <span>{props.filter.title}</span>
            </DropdownToggle>
            <DropdownMenu>
                {
                    Object.keys(props.filter.dropDown).map((key, index) => {

                        return (
                            <DropdownItem
                                className="dropdown-item-filter-type-checkbox"
                                key={`sort-by-${index}`}
                                onClick={() => {
                                    setDropdownItem(key)
                                    props.setFilter(key)
                                }}>

                                {
                                    props.isCheckBox &&
                                    <CustomInput
                                        type="checkbox"
                                        key={`filter-type-checkbox-${index}`}
                                        id={`filter-type-checkbox-${props.index}`}
                                        name={`filter-type-checkbox-${props.index}`}
                                        className="filter-type-checkbox"
                                        value={props.filter.dropDown[key]}
                                        onChange={()=>{}}
                                        {...(props.defaultFilter.toLowerCase() === "all"
                                            ? {checked: true}
                                            : {checked: props.defaultFilter.toLowerCase().indexOf(props.filter.dropDown[key].toLowerCase()) >= 0})}

                                    />
                                }

                                <span>{_.capitalize(props.filter.dropDown[key])}</span>
                            </DropdownItem>
                        )
                    })
                }
            </DropdownMenu>
        </Dropdown>
    );
}

FilterTypeComponent.propTypes = {
    filter: PropTypes.object.isRequired,
    defaultFilter: PropTypes.string.isRequired,
    setFilter: PropTypes.func.isRequired,
    isCheckBox: PropTypes.bool,
};

FilterTypeComponent.defaultProps = {
    isCheckBox: false
}
export default FilterTypeComponent;